import { AUTH_ERROR_CODES } from 'constants/common'
import {
  CONFIRM_SIGN_IN_FAILED_API_RESPONSE_ERROR_MESSAGE,
  DEFAULT_MFA_ERROR_MESSAGE,
  INCORRECT_SMS_ERROR_MESSAGE,
  INCORRECT_TOTP_ERROR_MESSAGE,
  INVALID_MFA_CODE_API_RESPONSE_ERROR_MESSAGE,
} from 'constants/message'
import { AuthChallengeType } from 'types/graphql'

export const formatMFAErrorMessage = ({
  error,
  loginEvent,
}: {
  error: unknown
  loginEvent: AuthChallengeType
}) => {
  const { code, message } = (error || {}) as Error & {
    code?: string
  }
  const isTOTPLoginEvent = loginEvent === AuthChallengeType.SoftwareTokenMfa

  if (
    code === AUTH_ERROR_CODES.INVALID_MFA_CODE ||
    message?.includes(INVALID_MFA_CODE_API_RESPONSE_ERROR_MESSAGE)
  ) {
    return isTOTPLoginEvent
      ? INCORRECT_TOTP_ERROR_MESSAGE
      : INCORRECT_SMS_ERROR_MESSAGE
  }

  if (message === CONFIRM_SIGN_IN_FAILED_API_RESPONSE_ERROR_MESSAGE) {
    return DEFAULT_MFA_ERROR_MESSAGE
  }

  return message
}
